import { Component, Vue } from "vue-property-decorator";
import {DocumentsModule, UsersModule} from '@/store/store.helper';
import * as storeHelper from '@/store/store.helper';
import { NAVBAR_COLOR, NAVBAR_SIDE_ICON, NavBarInterface } from "@/store/types";
import * as enums from '@/types/enums';

@Component({})

export default class Summary extends Vue {

    @DocumentsModule.DocumentsGetter private documentSummary;
    @DocumentsModule.DocumentsGetter private documentId;

    @UsersModule.UsersGetter private user;
    @UsersModule.UsersGetter private userUid;
    @UsersModule.UsersAction private updateCurrentUser;
    @UsersModule.UsersGetter private isSignedIn;
    @UsersModule.UsersAction private signIn;

    private newDocumentVersionNotification: boolean = false;
    private newEditSuggestionNotification: boolean = false;
    private newSectionSuggestionNotification: boolean = false;
    private newArgument: boolean = false;

    private notifications = {
        newDocumentVersionNotification: false,
        newEditSuggestionNotification: false,
        newSectionSuggestionNotification: false,
        newArgumentOrCommentNotification: false
    };
    /**
     * @return void
     */
    private created() {
        if ('documents' in this.user.notifications) {
            if (this.documentId in this.user.notifications.documents) {
                this.notifications = Object.assign({}, this.user.notifications.documents[this.documentId]);
            }
        }
    }
    private goToDraft(): void {
        this.$router.push({name: enums.ROUTE_NAME.draft});
    }
    private goToChoose(): void {
        this.$router.push({name: enums.ROUTE_NAME.chooseTopics})
    }
    private async updateNotification() {
        if (!this.isSignedIn) {
            this.signIn();
        } else {
            let documents;
            if ('documents' in this.user.notifications) {
                documents = Object.assign({}, this.user.notifications.documents);
            } else {
                documents = {};
            }
            documents[this.documentId] = this.notifications;
            console.log('documents', documents);
            let notifications = {...this.user.notifications, documents};
            console.log('notifications', notifications);

            await this.updateCurrentUser({
                updateObject: {notifications}
            });

            console.log('success', this.user);
        }
    }
}
